import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    readOnlyFields: [
        {
            label: "email",
            value: ""
        },
    ],
    form: [
        {
            field: "firstName",
            isReadOnly: false,
            value: "",
            error: false,
            errorMessage: "",
            type: "string",
            mandatory: false,
            display: false,
        },
        {
            field: "lastName",
            isReadOnly: false,
            value: "",
            error: false,
            errorMessage: "",
            type: "string",
            mandatory: false,
            display: false,
        },
        {
            field: "phoneNumber",
            isReadOnly: false,
            value: "",
            error: false,
            errorMessage: "",
            type: "number",
            mandatory: true,
            display: true,
        },
        {
            field: "password",
            isReadOnly: false,
            value: "",
            error: false,
            errorMessage: "",
            type: "string",
            mandatory: true,
            display: true,
        },
        {
            field: "language",
            isReadOnly: false,
            value: "",
            error: false,
            errorMessage: "",
            type: "dropdown",
            mandatory: false,
            display: true,
        },
        {
            field: "agreementCheck",
            isReadOnly: false,
            value: false,
            error: false,
            errorMessage: "",
            type: "checkbox",
            mandatory: true,
            display: true,
        },
    ],
}

export const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        setReadOnlyFields: (state, action) =>
        {
            state.readOnlyFields = action.payload
        },
        setFormData: (state, action) =>
        {
            state.form = action.payload
        },
    }
});

export const { setReadOnlyFields, setFormData } = formSlice.actions;

export default formSlice.reducer;